import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Legend, Series, Size } from "devextreme-react/pie-chart";
import { AprEtsTabK as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabK = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const seniorFafsaNoPostSecondaryField = () => {
    const propertyName = pn<AprResponseModel>("seniorFafsaNoPostSecondary");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.seniorFafsaNoPostSecondary} {formatPercentTotal(props.data?.seniorFafsaNoPostSecondary, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const seniorFafsaWithPostSecondaryField = () => {
    const propertyName = pn<AprResponseModel>("seniorFafsaWithPostSecondary");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.seniorFafsaWithPostSecondary} {formatPercentTotal(props.data?.seniorFafsaWithPostSecondary, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const seniorNoFafsaField = () => {
    const propertyName = pn<AprResponseModel>("seniorNoFafsa");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.seniorNoFafsa} {formatPercentTotal(props.data?.seniorNoFafsa, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
        {/* {props.totalTabA != props.data?.totalParticipants && (
          <Typography color="error" variant="caption">
            Your Total Participants does not equal Total Participants in section A
          </Typography>
        )} */}
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">
          FAFSA Completion
        </Typography>
        <Grid container spacing="lg">
          <Grid item xs={11}>
            <Grid container spacing="lg">
              <Grid item xs={12}>
                {seniorFafsaNoPostSecondaryField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {seniorFafsaWithPostSecondaryField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {seniorNoFafsaField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
